import React, { useState, useRef, useEffect } from 'react'
import DOMPurify from 'dompurify'
import Dropdown from './Dropdown'
import { NavMenuItemsProps } from './Navigation.types'
import { ANALYTICS_TYPES } from '../../../SiteNav/util'
import { handleLinkClick } from '../utils/common-utils'

// Main Nav Items. (depth 0)
const NavMenuItem = ({
  item,
  depthLevel,
  index,
  currentFocusMenu,
  totalSubmenus,
  firstNavItemRef,
  styles,
  activeTab,
  updateCurrFocusedIndex,
  textSizeClass,
  menuIconDisable,
  isRightButton,
  enableAnalytics,
}: NavMenuItemsProps) => {
  const [dropDownVisible, setDropDownVisible] = useState<boolean>(false)
  const [mouseOver, setMouseOver] = useState<boolean>(false)
  const showDropdown: boolean = item?.HstMenuItemRepresentation?.parameters?.showDropdown === 'true'
  const hasSubmenu: boolean = Boolean(item?.HstMenuItemRepresentation?.menuItems?.length)
  const linkRef = useRef<HTMLAnchorElement>(null)
  const dataAnalyticsValue = item?.HstMenuItemRepresentation?.parameters?.['data-analytics']
    ? item?.HstMenuItemRepresentation?.parameters?.['data-analytics']
    : item.HstMenuItemRepresentation.name
  let usedNavRef = firstNavItemRef || linkRef

  useEffect(() => {
    if (index === currentFocusMenu && usedNavRef?.current) {
      usedNavRef.current.focus()
    }
  }, [currentFocusMenu, usedNavRef.current])
  useEffect(() => {
    if (currentFocusMenu === null) {
      if (dropDownVisible) setDropDownVisible(false)
      return
    }

    if (currentFocusMenu >= index && currentFocusMenu <= index + (totalSubmenus || 0)) {
      setDropDownVisible(showDropdown && hasSubmenu)
    } else {
      setDropDownVisible(false)
    }
  }, [currentFocusMenu])
  const onMouseEnterLink = () => {
    setDropDownVisible(showDropdown && hasSubmenu)
    setMouseOver(true)
  }
  const onMouseLeaveLink = () => {
    setDropDownVisible(false)
    setMouseOver(false)
  }
  const onFocus = () => {
    if (currentFocusMenu !== index) {
      updateCurrFocusedIndex(index)
    }
    onMouseEnterLink()
  }
  const linkStyle: {
    color: string
    borderBottomColor: string | undefined
  } = {
    color:
      mouseOver || activeTab === item.HstMenuItemRepresentation.name
        ? styles.linkTextColorHover
        : styles.linkTextColor,
    borderBottomColor: undefined,
  }
  if (activeTab === item.HstMenuItemRepresentation.name) {
    linkStyle.borderBottomColor = styles.navTabSelectedBorderBottom
  }
  if (mouseOver || dropDownVisible) {
    linkStyle.borderBottomColor = styles.navTabHoverBorderBottom
  }
  const type = isRightButton ? ANALYTICS_TYPES.NAV_TRAY : ANALYTICS_TYPES.NAV
  return (
    <li
      onMouseEnter={onMouseEnterLink}
      onMouseLeave={onMouseLeaveLink}
      className={`menu-items menu-items-${depthLevel} ${textSizeClass}`}>
      <a
        onFocus={onFocus}
        onBlur={onMouseLeaveLink}
        onClick={
          enableAnalytics
            ? e =>
                handleLinkClick(
                  e,
                  type,
                  dataAnalyticsValue,
                  item.HstMenuItemRepresentation.parameters.analyticsSatellite
                )
            : undefined
        }
        ref={usedNavRef}
        data-icon={''}
        data-analytics={dataAnalyticsValue}
        className={`u-linkClean ${
          showDropdown && hasSubmenu && !menuIconDisable ? 'Icon--after ' : ''
        }u-flex u-flexAlignItemsCenter u-paddingVert2gu`}
        href={DOMPurify.sanitize(item.HstMenuItemRepresentation.url)}
        style={linkStyle}
        aria-current={activeTab === item.HstMenuItemRepresentation.name ? 'page' : 'false'}>
        {item.HstMenuItemRepresentation.name}
      </a>
      {dropDownVisible && (
        <Dropdown
          depthLevel={depthLevel}
          submenus={item.HstMenuItemRepresentation.menuItems || []}
          dropdown={dropDownVisible}
          dropdownIndex={index + 1}
          currentFocusMenu={currentFocusMenu}
          textSizeClass={textSizeClass}
          totalSubmenus={totalSubmenus}
          updateCurrFocusedIndex={updateCurrFocusedIndex}
          styles={styles}
          countDownOffset={0}
          parentDropdownLength={0}
          parentName={item.HstMenuItemRepresentation.name}
          enableAnalytics={enableAnalytics}
        />
      )}
    </li>
  )
}
export default NavMenuItem
